const configs = {
  open:                'bg-blue-100 text-blue-700 ring-1 ring-blue-200',
  partially_fulfilled: 'bg-amber-100 text-amber-700 ring-1 ring-amber-200',
  fulfilled:           'bg-sky-100 text-sky-700 ring-1 ring-sky-200',
  received:            'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200',
  cancelled:           'bg-slate-100 text-slate-500 ring-1 ring-slate-200',
  pending:             'bg-amber-100 text-amber-700 ring-1 ring-amber-200',
  awaiting_approval:   'bg-orange-100 text-orange-700 ring-1 ring-orange-200',
  approved:            'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200',
  rejected:            'bg-red-100 text-red-700 ring-1 ring-red-200',
  completed:           'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200',
  active:              'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200',
  inactive:            'bg-slate-100 text-slate-500 ring-1 ring-slate-200',
  sent:                'bg-sky-100 text-sky-700 ring-1 ring-sky-200',
  super_admin:         'bg-purple-100 text-purple-700 ring-1 ring-purple-200',
  admin:               'bg-primary-100 text-primary-700 ring-1 ring-primary-200',
  user:                'bg-slate-100 text-slate-600 ring-1 ring-slate-200',
};

export default function StatusBadge({ status, label }) {
  const cls = configs[status] || 'bg-slate-100 text-slate-600 ring-1 ring-slate-200';
  const display = label ?? status?.replace(/_/g, ' ');
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold capitalize whitespace-nowrap ${cls}`}>
      {display}
    </span>
  );
}
